import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import {
  NavDropdown,
  MenuItem,
} from 'react-bootstrap';
import Avatar from 'react-avatar';

class UserMenu extends React.Component {

  render() {
    const profile = this.props.profile;
    if (!profile.user) {
      return null;
    }
    let name = profile.user.username;
    if (profile.user.first_name && profile.user.last_name) {
      name = `${profile.user.first_name} ${profile.user.last_name}`;
    }
    const optProps = {
      size: 32,
      round: true,
      ...(profile.image && { src: profile.image }),
      ...(profile.custom_image && { src: profile.custom_image }),
    };

    const dropDown = (<Avatar
      name={name}
      {...optProps}
    />);
    const menuItems = this.props.menu.map((menu, i) =>
      <Link key={i} to={menu.to}>
        <li className="list-group-item d-flex align-items-center">
          <i className={menu.icon} aria-hidden="true" />
          <h5>{menu.name}</h5>
        </li>
      </Link>,
    );

    return (
      <ul className="list-group profile">
        <Link to='/profile'>
          <li className="list-group-item d-flex align-items-center">
            <Avatar name={name} {...optProps} />
            <h5>Profile</h5>
          </li>
        </Link>
        {menuItems}
        <a onClick={this.props.logout} href="/login">
          <li className="list-group-item d-flex align-items-center">
            <i className="fa fa-sign-out" aria-hidden="true" />
            <h5>Logout</h5>
          </li>
        </a>
      </ul>
    );
  }
}
UserMenu.propTypes = {
  profile: PropTypes.object.isRequired,
  UserMenu: PropTypes.arrayOf(PropTypes.object).isRequired,
  logout: PropTypes.func.isRequired,
};
UserMenu.defaultProps = {
  profile: {},
  UserMenu: [],
};

export default UserMenu;



// WEBPACK FOOTER //
// src/components/Sidebar/UserMenu.js